






























import { Component, Prop, Ref, Vue } from 'vue-property-decorator';
import { DateTime } from 'luxon';
import BasePopper from '../base-popper/_base-popper.vue';
import BaseInput from '../base-input/_base-input.vue';
import BaseDatepicker from './_base-datepicker.vue';

@Component({
  name: 'BaseDatepickerInput',
  components: {
    BaseDatepicker,
    BasePopper,
    BaseInput,
  },
})
export default class BaseDatepickerInput extends Vue {
  @Prop() placeholder: string;
  @Prop() format: string;
  @Prop() maximumView: string;
  @Prop() minimumView: string;
  @Prop() value: string;
  @Prop() label: string;
  @Prop() useUtc: boolean;
  @Prop() enableTime: boolean;
  @Prop({ default: '' }) errorMessage: string;
  @Prop() disabledDates: Record<string, any>;
  @Prop({ default: false }) closeAfterSelect?: boolean;
  @Ref('datepickerInput') datepickerInput: BaseInput;
  @Ref('datepickerContainer') datepickerContainer: HTMLElement;
  @Prop({ default: false }) appendToBody: boolean;
  @Prop() dataExternal?: string;

  show = false;
  get inputId(): string {
    return `input-${this['_uid']}`;
  }
  get formattedValue() {
    if (!this.value) {
      return '';
    }
    const format = this.enableTime ? DateTime.DATETIME_MED : DateTime.DATE_FULL;
    if (this.useUtc) {
      return DateTime.fromISO(this.value).toUTC().toLocaleString(format);
    }
    return DateTime.fromISO(this.value).toLocaleString(format);
  }
  focus() {
    (this.datepickerInput as any).focus();
  }
  handleFocus() {
    this.show = true;
  }
  isSelf(target: Node) {
    const isChildComponent = this.datepickerContainer.contains(target as Node);
    const isDatePickerInput = this.datepickerInput.$el.contains(target);
    return isChildComponent || isDatePickerInput;
  }
  handleBlur() {
    setTimeout(() => {
      const currentElement: Element = document.activeElement;
      if (!this.isSelf(currentElement)) {
        this.show = false;
      }
    });
  }
  handleSelect(date: string) {
    this.$emit('select', date);
    if (this.closeAfterSelect) {
      (this.datepickerInput as any).blur();
    }
  }
}
